export default {
    props: {
        /**
         * Loader overlay state
         */
        overlay: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /**
         * Returns unique id for loader DOM element
         * @returns {number}
         */
        uniqueIdOfLoader() {
            // eslint-disable-next-line no-underscore-dangle
            return this._uid;
        },
    },
};
